<template>

    <form autocomplete="off" class="trax-form mb-4">

        <trax-ui-choice :placeholder="lang.polaris.dashboard.grade" col="md-3"
            v-model="form.grade" :error="errors.grade" :options="grade_select" required="1" 
            v-if="item.meta.crew_type == undefined || item.meta.crew_type != 'solo'">
        </trax-ui-choice>

        <trax-ui-input :placeholder="lang.polaris.dashboard.comments" col="md-3"
            v-model="form.comments" :error="errors.comments" rows="5">
        </trax-ui-input>

        <trax-ui-toggle :text="lang.polaris.dashboard.atp_needed" col="md-3" 
            v-model="form.procedure">
        </trax-ui-toggle>

        <trax-ui-toggle text="Deferred items" col="md-3" 
            v-model="form.goals_enabled"
            v-if="goalsAvailable"
        ></trax-ui-toggle>

        <trax-ui-input placeholder="Deferred items" col="md-3"
            v-model="form.goals" :error="errors.goals" rows="5"
            v-if="goalsAvailable && form.goals_enabled"
        ></trax-ui-input>

    </form>

</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-flight-follow-up-learner-edit'},
            source: {default: '3'},
            target: {default: 'final'}
        },

        data: function() {
            return {
                lang: lang,
                item: data.item,
                grade_select: data.grade_select,
                form: {
                    grade: '',
                    grade_max: data.grade_select.length,
                    comments: '',
                    procedure: 0,
                    goals_enabled: 0,
                    goals: ''
                },
                errors: {},
                bus: this.$bus
            }
        },
        
        created: function() {
            this.bus.$on(this.id+'-states-data', this.setStates);
            this.bus.$on(this.id+'-states-updated', this.setStates);
            this.bus.$on(this.id+'-'+this.source+'-states-save', this.saveData);
            this.bus.$on(this.id+'-states-errors', this.setErrors);
        },

        computed: {

            goalsAvailable() {
                return this.item.meta.crew_type == 'dual'   // Only for dual
                    && !this.item.registration_id           // Not available for cutom sessions
            }
        },

        methods: {

            setStates(states) {
                if (!states.summary) {
                    this.form.grade = '';
                    this.form.comments = '';
                    this.form.procedure = 0;
                    this.form.goals_enabled = 0;
                    this.form.goals = '';

                    if (states.postponed && states.postponed.goals_enabled) {
                        this.form.goals_enabled = 1;
                        this.form.goals = states.postponed.goals;
                    }
                    return;
                }
                this.form.grade = states.summary.data.grade;
                this.form.comments = states.summary.data.comments;
                this.form.procedure = states.summary.data.procedure;
                this.form.goals_enabled = states.summary.data.goals_enabled ? states.summary.data.goals_enabled : 0;
                this.form.goals = states.summary.data.goals ? states.summary.data.goals : '';
            },

            setErrors(errors) {
                var my_errors = {};
                for (var index in errors) {
                    my_errors[index.split('.')[1]] = errors[index];
                }
                this.errors = my_errors;
            },

            saveData(data) {
                this.errors = {};
                for (var prop in this.form) { data.summary[prop] = this.form[prop]; }
                this.bus.$emit(this.id+'-'+this.target+'-states-save', data);
            }
        }
    }
</script>
